module.exports = __webpack_public_path__ + "img/table.80f93a96.png";